export default __webpack_public_path__ + "static/media/white_check.309c3c58.svg";